// extracted by mini-css-extract-plugin
export default {"card":"profileCode_card__Cj-+0 profile_card__scoH3","pre":"profileCode_pre__i5aMR"};